import { Button, Span } from "@icg360/design-system";

import styles from "components/notifications/notifications-drawer/notification-item.module.scss";
import { trackEvent } from "utils";

import { useNotifications } from "../context";
import { PolicyCards } from "./policy-cards";

const MARK_READ_WAIT_MS = 1500;

export const NotificationItem = () => {
  const { notifications, dismiss, closeDrawer } = useNotifications();
  return (
    <div className={styles.notificationsGroup}>
      {notifications.map((notification) => {
        const notificationTitle = notification.title;
        const notificationButtonText = notification.actionLabel ?? "View";
        const isUnread = !notification.read;
        const showPolicyCards = notification.id.startsWith("policy-link");
        return (
          <div
            key={notification.id}
            className={
              isUnread
                ? styles.unreadNotificationHolder
                : styles.notificationHolder
            }
          >
            <div className={styles.notificationContent}>
              <Span size="md" className={styles.notificationTitle}>
                {notificationTitle}
              </Span>
              <Span size="sm" className={styles.notificationDescription}>
                {notification.description}
              </Span>
            </div>
            {showPolicyCards && (
              <PolicyCards policyIds={notification.policyIds} />
            )}
            <div className={styles.notificationActions}>
              <Button
                appearance="secondary"
                size="md"
                aria-label={`Dismiss ${notificationTitle}`}
                data-testid={`notification-dismiss-button-${notification.id}`}
                onPress={() => {
                  trackEvent("Notification dismissed", {
                    notificationId: notification.id,
                  });
                  dismiss([notification]);
                }}
              >
                Dismiss
              </Button>
              {notification.actionUrl && (
                <Button
                  className={styles.learnMoreButton}
                  appearance="primary"
                  size="md"
                  aria-label={`Click to learn more about ${notificationTitle}`}
                  data-testid={`notification-cta-button-${notification.id}`}
                  onPress={async () => {
                    trackEvent("Notification CTA clicked", {
                      notificationId: notification.id,
                      path: notification.actionUrl,
                    });
                    // A full page load cancels in-flight requests, so let the
                    // mark-read PATCH land first, but don't hold the user up
                    // for longer than MARK_READ_WAIT_MS if it's slow.
                    await Promise.race([
                      closeDrawer(),
                      new Promise((resolve) =>
                        setTimeout(resolve, MARK_READ_WAIT_MS),
                      ),
                    ]);
                    window.location.assign(notification.actionUrl!);
                  }}
                >
                  {notificationButtonText}
                </Button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
